<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center"
    >
      Instruktur RPL
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
        >Kembali</Button
      >
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Tambah</div> -->
    <div class="card-body">
      <!-- Form Tambah Workshop -->
      <form @submit.prevent="postData">
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Instruktur RPL</div>
          <div class="card-body" id="coba">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">Nama Lengkap</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  placeholder="Masukkan Nama Instruktur"
                  v-model="formData.nama"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="nama"
                  placeholder="Masukkan Email"
                  v-model="formData.email"
                  required
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">No. Telepon</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  placeholder="Masukkan No. Telepon"
                  v-model="formData.noTelephone"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Alamat</label>
                <textarea
                  col="2"
                  type="text"
                  class="form-control"
                  id="nama"
                  placeholder="Masukkan Alamat"
                  v-model="formData.alamat"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">Instansi</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  placeholder="Masukkan Nama Instansi"
                  v-model="formData.instansi"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">
                  CV
                  <small>
                    <a @click="cekFile()">(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    @change="fileUpload"
                  />
                  <label
                    class="custom-file-label"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                    >{{ fileName }}</label
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="kode" class="font-weight-bold">NPWP</label>
                <input
                  type="text"
                  class="form-control"
                  id="kode"
                  placeholder="Masukkan No. NPWP"
                  v-model="formData.npwp"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Akun Bank</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  placeholder="Masukkan Akun Bank"
                  v-model="formData.akunBank"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <CCol sm="6" class="pl-1">
          <label for class="font-weight-bold">Status</label>
          <br />
          <div class="d-flex align-items-center">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="customRadio"
                id="aktif"
                value="1"
                v-model="formData.status"
                checked
              />
              <label class="custom-control-label" for="aktif">Aktif</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="customRadio"
                id="tidak_aktif"
                value="0"
                v-model="formData.status"
              />
              <label class="custom-control-label" for="tidak_aktif"
                >Tidak Aktif</label
              >
            </div>
          </div>
        </CCol>
      </form>
      <!-- End Form Tambah Workshop -->
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <Button
        class="btn btn-md btn-success px-4 py-2"
        type="submit"
        color="success"
        @click="postData"
        >Simpan</Button
      >
    </div>
  </div>
</template>
<script>
import InstrukturRplService from "../../../services/sertifikasi/master-rpl-instruktur.service";
import baseUrl from "../../../services/base-url";

export default {
  name: "MasterRplInstruktur",
  data() {
    return {
      actionPost: "",
      baseUrl: "",
      formData: {
        nama: "",
        alamat: "",
        noTelephone: "",
        email: "",
        instansi: "",
        cv: "",
        npwp: "",
        akunBank: "",
        status: "",
      },

      fileName: "Pilih File",
    };
  },
  mounted() {
    this.baseUrl = baseUrl();
    this.getData();
  },

  methods: {
    cekFile() {
      if (this.formData.cv != "" && this.formData.cv != null) {
        let routeData =
          this.baseUrl +
          "/uploads/sertifikasi/master_rpl/instruktur_rpl_cv/" +
          this.formData.cv;
        window.open(routeData, "_blank");
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true,
        });
      }
    },

    fileUpload(e) {
      this.formData.cv = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "error",
        showCancelButton: true,
      });
    },

    alertSuccess() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan",
      });
    },

    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      var vm = this;
      InstrukturRplService.getDetailInstrukturRpl(
        this.$route.params.idInstrukturRpl
      )
        .then((response) => {
          loader.hide();
          vm.formData = response.data.singleData;
          this.fileName = response.data.singleData.cv;
          // comment console console.log(response);
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    postData() {
      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      // comment console console.log(formData);
      // comment console console.log("put");

      /* hapus data jika tidak ada perubahan pada file */
      if (typeof formData.cv === "string") {
        delete formData.cv;
      }
      if (formData.cv === null) {
        delete formData.cv;
      }

      var vm = this;
      InstrukturRplService.postInstrukturRpl(formData)
        .then((response) => {
          loader.hide();

          vm.myModal = false;
          vm.alertSuccess();

          vm.$router.push({ path: "/sertifikasi/master-rpl-instrukturrpl" });
        })
        .catch((error) => {
          loader.hide();

          // comment console console.log(error);
        });
    },
    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log("put");
      // comment console console.log(this.formData);

      InstrukturRplService.putInstrukturRpl(this.formData)
        .then((response) => {
          loader.hide();
          // comment console console.log(response);
          this.myModal = false;
          this.alertSuccess();
          this.$router.push({ path: "/sertifikasi/master-rpl-instrukturrpl" });
        })
        .catch((error) => {
          // comment console console.log(error);

          this.alertError();
        });
    },
  },
};
</script>